<template>
  <div class="selected-lpo-header">
    <div class="lpo-info wrapper">
      <div class="lpo-info__address">{{ selectedLpoAddress }}</div>
      <div v-if="selectedLpo.inspection_type" class="lpo-info__inspection-type">
        {{ selectedLpo.inspection_type }}
      </div>
      <div v-if="selectedLpo.inspection_date" class="lpo-info__inspection-type">
        {{ normalizeDate(selectedLpo.inspection_date) }}
      </div>
    </div>

    <div class="tabs-block">
      <div class="wrapper">
        <p-tabmenu :model="tabItems" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "SelectedLpoHeader",

  data: () => ({
    tabItems: [
      // { label: 'Общая информация', icon: 'fa fa-home', to: { name: 'current-lpo-general' } },
      {
        label: "Участок",
        icon: "fa fa-home",
        to: { name: "current-lpo-section" },
      },
      {
        label: "Границы и площадь",
        icon: "fa fa-vector-square",
        to: { name: "current-lpo-geometry" },
      },
      // { label: 'Деревья', icon: 'fa fa-tree', to: { name: 'current-lpo-recount' } },
      {
        label: "Данные обследования",
        icon: "fa fa-database",
        to: { name: "current-lpo-inspection" },
      },
      {
        label: "Результаты обследования",
        icon: "fa fa-clipboard-check",
        to: { name: "current-lpo-result" },
      },
    ],
  }),

  computed: {
    selectedLpoAddress() {
      const section_lp_str = this.currentLpo.section_lp
        ? " (" + this.currentLpo.section_lp + ")"
        : "";

      const arr = [];

      arr.push(this.currentLpo.forestry);
      arr.push(this.currentLpo.localforestry);

      if (this.currentLpo.subforestry) {
        arr.push(this.currentLpo.subforestry);
      }

      arr.push(this.currentLpo.area);
      arr.push(this.currentLpo.section + section_lp_str);

      return arr.join(" / ");
    },

    ...mapState("selectedLpo", {
      selectedLpo: (state) => state.lpo,
    }),

    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
    }),
  },

  methods: {
    normalizeDate(date) {
      return date
        .split("-")
        .reverse()
        .join(".");
    },
  },
};
</script>

<style scoped src="@/style/wrapper.css"></style>

<style scoped>
.selected-lpo-header {
  box-shadow: 0 0.01rem 0.7rem #414141;
  z-index: 10;
  background: white;
  position: sticky;
  top: 0;
}

.lpo-info {
  color: #6c757d;
  display: flex;
  font-size: 1.2rem;
  justify-content: space-between;
  font-weight: bold;
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}
</style>

<style lang="scss" scoped>
@import "@/style/constants.scss";

$tabs-gap: 3px;

.tabs-block {
  background-color: #d9d9d9;
  padding: $tabs-gap 0;
}

.p-tabmenu::v-deep .p-tabmenu-nav {
  background-color: inherit;
  border: none;
  gap: $tabs-gap;
}

.p-tabmenu::v-deep .p-tabmenuitem {
  flex: 1;
}

.p-tabmenu::v-deep .p-menuitem-link {
  border: none !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  justify-content: center;
  margin: 0 !important;
  height: 100%;

  transition: all ease 0.2s !important;
}

.p-tabmenu::v-deep .p-menuitem-link:focus {
  box-shadow: none !important;
}

.p-tabmenu::v-deep .p-menuitem-link:hover {
  // color: #2CC185 !important;
  color: $color-green !important;
}

.p-tabmenu::v-deep .p-menuitem-link.router-link-active {
  background-color: $color-green !important;
  // background-color: #2CC185 !important;
  color: #fff !important;
}
</style>
